import { RootState } from "../root.reducer";

export const languageSelector = (state: RootState) => state.language;
